"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const common_components_1 = require("@as-react/common-components");
const react_redux_1 = require("react-redux");
const ProductPreview_1 = tslib_1.__importDefault(require("../../components/product-detail/product-preview/ProductPreview"));
const ProductSelector_1 = require("../../redux/product/selectors/ProductSelector");
const ProductPreviewSelectors_1 = require("../../redux/productPreview/selectors/ProductPreviewSelectors");
const ProductPreviewActions_creators_1 = require("../../redux/productPreview/actions/ProductPreviewActions.creators");
const AddToWishlistButton_1 = tslib_1.__importDefault(require("../../components/product-detail/add-to-wishlist-button/AddToWishlistButton"));
const cotopaxi_1 = require("@as/cotopaxi");
const WishListActions_creators_1 = require("../../redux/wishList/actions/WishListActions.creators");
const WishListSelectors_1 = require("../../redux/wishList/selectors/WishListSelectors");
const ProductPreviewContainer = ({ alt, dynamicSavingsInformation, previewInformation, productDefaults, selectedColorId, videos, showImageTouchZoomHint, ourPlanet, newProduct, onImageTouchZoom, }) => {
    const { productImageConfig, feature_toggles, isShopLanding } = (0, common_components_1.useAemConfig)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const selectedSku = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetSelectedSku)());
    const { productCode, productId } = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductDefaults)());
    const productColorIsInWishList = (0, react_redux_1.useSelector)((0, WishListSelectors_1.makeGetProductColorIsInWishList)());
    const savingsPercentage = (dynamicSavingsInformation === null || dynamicSavingsInformation === void 0 ? void 0 : dynamicSavingsInformation.productDiscountPercentage)
        ? {
            savingsPercentage: dynamicSavingsInformation.productDiscountPercentage,
        }
        : null;
    const wishListProduct = {
        colorId: selectedColorId,
        productCode: productCode,
        productId: parseInt(productId, 10),
        sku: selectedSku,
    };
    const handleToggleWishlist = () => {
        dispatch(WishListActions_creators_1.wishListActions.toggleProduct(wishListProduct));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ProductPreview_1.default, Object.assign({ genderCode: productDefaults.genderFeatureId, images: previewInformation.images, priceOverlay: previewInformation.priceOverlay, productImages: productImageConfig, productCode: productDefaults.productCode, showGenderIcon: feature_toggles.product_gender_icon, showOnlineExclusiveLabel: feature_toggles.product_online_exclusive && previewInformation.webOnly, alt: alt, videos: videos, selectedColorId: selectedColorId, showImageTouchZoomHint: showImageTouchZoomHint, showSustainabilityLabel: ourPlanet, showNewProductLabel: feature_toggles.product_new_label && newProduct, onImageTouchZoom: onImageTouchZoom }, savingsPercentage)), !isShopLanding && ((0, jsx_runtime_1.jsx)(AddToWishlistButton_1.default, { isProductInWishList: productColorIsInWishList, onToggle: handleToggleWishlist, wishListProduct: wishListProduct, buttonProps: {
                    shape: cotopaxi_1.ButtonShape.PILL,
                    variant: cotopaxi_1.ButtonVariant.INVERSE_ALT,
                    size: cotopaxi_1.ButtonSize.NORMAL,
                } }))] }));
};
const makeMapStateToProps = () => {
    const getPreviewInformation = (0, ProductSelector_1.makeGetPreviewInformation)();
    const getProductImageAlt = (0, ProductSelector_1.makeGetProductImageAlt)();
    const getProductDefaults = (0, ProductSelector_1.makeGetProductDefaults)();
    const getDynamicSavingsInformation = (0, ProductSelector_1.makeGetDynamicSavingsInformation)();
    const getSelectedColorId = (0, ProductSelector_1.makeGetSelectedColorId)();
    const getShowImageTouchZoomHint = (0, ProductPreviewSelectors_1.makeGetShowImageTouchZoomHint)();
    const getProductOurPlanet = (0, ProductSelector_1.makeGetProductOurPlanet)();
    const getNewProduct = (0, ProductSelector_1.makeGetNewProduct)();
    return (state) => ({
        previewInformation: getPreviewInformation(state),
        productDefaults: getProductDefaults(state),
        alt: getProductImageAlt(state),
        dynamicSavingsInformation: getDynamicSavingsInformation(state),
        selectedColorId: getSelectedColorId(state),
        showImageTouchZoomHint: getShowImageTouchZoomHint(state),
        ourPlanet: getProductOurPlanet(state),
        newProduct: getNewProduct(state),
    });
};
const mapDispatchToProps = {
    onImageTouchZoom: ProductPreviewActions_creators_1.productPreviewActions.disableImageTouchZoomHint,
};
exports.default = (0, react_redux_1.connect)(makeMapStateToProps, mapDispatchToProps)(ProductPreviewContainer);
